import { lazy } from "react"
import { Route } from "react-router-dom"
import { lazyRetry } from "./utils"
import { AuthenticatedLayout } from "./wrappers"
import LegendPanel from "@components/Calendar/LegendPanel"

const CalendarNew = lazy(() => lazyRetry(() => import("../views/Event/CalendarNew"), "calendarNew"))

const CalendarRoute = (
	<Route path="/calendar" element={<AuthenticatedLayout className="calendar-layout" rightPanel={<LegendPanel />} />}>
		<Route path="/calendar" element={<CalendarNew />} />
	</Route>
)

export default CalendarRoute
